/* eslint-disable react/prefer-stateless-function */
/**
 * The HOC is used to translate text based on intl setting.
 * @author: Ronan
 */
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';

const propTypes = {
  intl: intlShape.isRequired,
};

const mapStateToProps = ({ global }) => ({
  lang: global.language,
});

const getI18ns = labels => (WrappedComponent) => {
  const i18nWrapper = ({ intl }) => {
    const { formatMessage } = intl;
    const i18ns = {};
    _.forOwn(labels, (i18nId, key) => {
      i18ns[key] = formatMessage({ id: i18nId });
    });
    return (
      <WrappedComponent
        i18ns={i18ns}
        {...this.props}
      />
    );
  };
  i18nWrapper.propTypes = propTypes;
  return connect(mapStateToProps)(injectIntl(i18nWrapper));
};

export default getI18ns;



// WEBPACK FOOTER //
// ./src/components/hoc/getI18ns.jsx